"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flatten;

function flatten(inArr) {
  var arr = [];

  for (var i = 0; i < inArr.length; i++) {
    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
  }

  return arr;
}